<template>
  <van-row class="chats">
    <van-popup
        v-model="toUserInfoshow"
        position="top"
        :style="{ height: '30%' }"
        closeable
        round
    >
      <van-row class="toUserInfo-box" v-if="userType==='company'">
        <div class="line-1">
          <p class="resume-name">{{toUserData.realname}}</p>
          <p class="chat-title">
            洽谈职位：<span class="job-name">{{toUserData.job_name}}</span>
          </p>
        </div>
        <div class="line-2">
          <div class="icon_edu" style="margin-right: 1rem;" v-show="!isEmptyVal(toUserData.education_cn)">
            {{toUserData.education_cn}}
          </div>
          <div class="icon_exp" style="margin-right: 1rem;" v-show="!isEmptyVal(toUserData.experience_cn)">
            {{toUserData.experience_cn}}
          </div>
          <div class="icon_age" v-show="!isEmptyVal(toUserData.age)">
            {{toUserData.age+"岁"}}
          </div>
        </div>
        <div class="line-3">
          <!--            工作信息-->
          <div class="edu-item">
            <div class="com-logo"><i></i></div>
            <div class="edu-right" v-if="
            !isEmptyVal(toUserData.work_companyname)&&
            !isEmptyVal(toUserData.work_time)&&!isEmptyVal(toUserData.work_job)">
              <div class="edu-1">
                <div class="school">{{toUserData.work_companyname}}</div>
                <div class="period">{{toUserData.work_time}}</div>
              </div>
              <div class="profession">{{toUserData.work_job}}</div>
            </div>
            <div class="edu-right" v-else>
              <div class="edu-1 empty">
                暂无数据
              </div>
              <div class="profession"></div>
            </div>
          </div>
          <!--            教育信息-->
          <div class="edu-item">
            <div class="school-logo"><i></i></div>
            <div class="edu-right" v-if="
            !isEmptyVal(toUserData.school)&&
            !isEmptyVal(toUserData.educaion_time)&&!isEmptyVal(toUserData.education_speciality)">
              <div class="edu-1">
                <div class="school">{{toUserData.school}}</div>
                <div class="period">{{toUserData.educaion_time}}</div>
              </div>
              <div class="profession">{{toUserData.education_speciality}}</div>
            </div>
            <div class="edu-right" v-else>
              <div class="edu-1 empty">
                暂无数据
              </div>
              <div class="profession"></div>
            </div>
          </div>
        </div>
      </van-row>
      <van-row class="toUserInfo-box">
        <div class="line-1">
          <div class="chat-title">洽谈职位：<span class="job-name">{{toUserData.job_name}}</span></div>
          <div class="job-salary">{{toUserData.wage_cn}}</div>
        </div>
        <div class="line-2">
          {{toUserData.companyname}}
        </div>
        <div class="line-3">
          <div v-if="toUserData.education_cn" style="margin-right: 1rem;" class="icon_edu">{{toUserData.education_cn}}</div>
          <div v-if="toUserData.experience_cn" style="margin-right: 1rem;" class="icon_exp">{{toUserData.experience_cn}}</div>
          <div v-if="toUserData.district_cn" class="icon_dist">{{toUserData.district_cn}}</div>
        </div>
        <div class="line-4" v-if="toUserData.jobs_content"><span>职位描述：</span>
          {{toUserData.jobs_content}}
        </div>
        <div class="line-4" v-else><span>职位描述：</span>
          暂无信息
        </div>
      </van-row>
    </van-popup>
    <van-row class="editor-box">
      <van-nav-bar
          :title="name"
          left-text="返回"
          left-arrow
          @click-left="onClickLeft"
      />
      <van-grid center column-num="3" v-if="userType==='company'">
        <van-grid-item icon="newspaper-o" text="索要简历" @click="handleSendViewResumeClick"/>
        <van-grid-item icon="close" text="结束洽谈" @click="closeNegotiationDialog=true"/>
        <van-grid-item icon="phone-o" text="发送手机" @click="handleSendMobileCompanyClick"/>
      </van-grid>
      <van-grid center column-num="3" v-if="userType==='person'">
        <van-grid-item icon="hotel-o" text="企业主页" @click="jumpCompany"/>
        <van-grid-item icon="close" text="结束洽谈" @click="closeNegotiationDialog=true"/>
        <van-grid-item icon="phone-o" text="发送手机" @click="handleSendMobilePersonClick"/>
      </van-grid>
      <van-skeleton title avatar animate :row="5" :loading="loadingMessage"/>
      <van-row class="messageList-box" v-if="messageListShow && !isEmptyVal(currentMessageList)"
               :style="toolbarStatus ? 'height:56%' : 'height:76%;'"
               ref="messageList-box"
      >
        <van-list
            :loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            class="messageList"
            direction="up"
        >
          <message-item v-for="message in currentMessageList" :key="message.ID" :message="message"/>
        </van-list>
      </van-row>
      <van-row style="position: fixed;bottom: 0;left:0;width:100%;">
        <van-row type="flex" justify="center" class="send-box">
          <van-col span="16">
            <van-field
                v-model="messageContent"
                placeholder=""
                rows="1"
                :autosize={maxHeight:180}
                type="textarea"
                class="input"
            />
          </van-col>
          <van-col span="8">
            <van-button type="primary" round size="small" style="margin-left: 10px;" @click="sendTextMessage">发送</van-button>
            <van-button type="primary" round size="small" style="margin-left: 4px;" @click="onSendBoxToolbarShow" v-if="toolbarStatus===0">更多</van-button>
            <van-button type="primary" round size="small" style="margin-left: 4px;" @click="onSendBoxEmojisShow" v-else-if="toolbarStatus===1">关闭</van-button>
            <van-button type="primary" round size="small" style="margin-left: 4px;" @click="onSendBoxToolbarShow" v-else>收起</van-button>
          </van-col>
        </van-row>
        <van-row class="tool" v-if="sendBoxToolbarShow">
          <van-grid column-num="3">
<!--            <van-grid-item icon="smile-o" text="表情" @click="onSendBoxEmojisShow" />-->
            <van-grid-item icon="photo-o" text="图片" @click="handleSendImageClick"/>
            <van-grid-item icon="orders-o" text="发送职位" v-if="userType==='company'" @click="sendJobsShow=true" />
            <van-grid-item icon="newspaper-o" text="发送简历" v-if="userType==='person'" @click="sendResumeShow=true" />
            <van-grid-item icon="user-o" text="对方信息" @click="toUserInfoshow=true" />
          </van-grid>
        </van-row>
        <van-row class="emojis" v-if="sendBoxEmojisShow">
          <van-grid :column-num="6">
            <van-grid-item
                v-for="item in emojiName"
                :key="item"
                :icon="emojiUrl + emojiMap[item]"
                text=""
                v-lazy="emojiUrl + emojiMap[item]"
                @click="chooseEmoji(item)"
            />
          </van-grid>
        </van-row>
      </van-row>
    </van-row>
    <input
        type="file"
        id="imagePicker"
        ref="imagePicker"
        accept=".jpg, .jpeg, .png, .gif, .bmp"
        @change="sendImage"
        style="display:none"
    />
    <van-action-sheet
        v-model="sendJobsShow"
        :actions="imUserInfo.jobs_list_m"
        cancel-text="取消"
        description="请选择一个职位发送"
        close-on-click-action
        @select="handleSendJobClick"
    />
    <van-action-sheet
        v-model="sendResumeShow"
        :actions="imUserInfo.resume_list_m"
        cancel-text="取消"
        description="请选择一个简历发送"
        close-on-click-action
        @select="handleSendResumeClick"
    />
    <van-action-sheet v-model="closeNegotiationDialog" title="请先对此次沟通进行评价">
      <div class="rate-content">
        <p>1星：待定/2星：合适/3星：不合适</p>
        <van-rate
            v-model="rateValue"
            :size="25"
            color="#ffd21e"
            void-icon="star"
            void-color="#eee"
            :count="3"
        />
        <van-button type="primary" round size="large" style="margin-top: 10px" @click="deleteConversationConfirm">结束洽谈并评价</van-button>
      </div>
    </van-action-sheet>
  </van-row>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import {isEmpty} from '@/utils/common'
import { emojiMap, emojiName, emojiUrl } from '@/utils/emojiMap'
import MessageItem from '@/components/message/message-item'

export default {
  name: 'ChatsView',
  data() {
    return{
      loadingMessage:false,
      messageListShow:true,
      messageContent:'',
      list: [],
      loading: false,
      finished: false,
      toUserInfoshow:false,
      toolbarStatus:0,
      sendBoxToolbarShow:false,
      sendBoxEmojisShow:false,
      emojiMap: emojiMap,
      emojiName: emojiName,
      emojiUrl: emojiUrl,
      sendJobsShow:false,
      sendResumeShow:false,
      scrollMessageListOne:0,//首次加载消息列表时，判断
      closeNegotiationDialog:false,
      rateValue:2,
    }
  },
  components:{
    MessageItem,
  },
  computed:{
    ...mapState('user',['userID','isSDKReady']),
    ...mapState('common',['imUserInfo','toUserData']),
    ...mapState('conversation',['currentMessageList','currentConversation','isCompleted']),
    ...mapGetters('conversation',['toAccount','currentConversationType']),
    name() {
      if (this.currentConversation.type === 'C2C') {
        return this.currentConversation.remark || this.currentConversation.userProfile.nick || this.currentConversation.userProfile.userID
      } else if (this.currentConversation.type === 'GROUP') {
        return this.currentConversation.groupProfile.name || this.toAccount
      } else if (this.currentConversation.conversationID === '@TIM#SYSTEM') {
        return '系统通知'
      }
      return this.toAccount
    },
    userType() {
      if (isEmpty(this.userID)) {
        return ''
      }
      const userId = this.userID
      let userIdData = userId.split('|')
      return userIdData[2]
    },
  },
  async created() {
    //滚动聊天信息到最新消息
    this.$bus.$on('scroll-bottom', this.scrollMessageListToButtom)
    this.$bus.$on('image-loaded', this.onImageLoaded)

    //获取洽谈对方信息
    await this.$store.dispatch('common/chatUserInfo', {
      userId: this.imUserInfo.im_user_id,
      toUserId: this.$route.query.userId,
    })
  },
  mounted() {
    //加载对话详情
    this.messageListShow=false
    this.$store.dispatch('conversation/checkoutConversation','C2C'+this.$route.query.userId).then(() => {
      this.messageListShow=true
    })
  },
  watch:{
    currentMessageList(val, oldVal){
      if (val.length > oldVal.length){
        //上报会话消息全部已读
        const conversationID = this.currentConversation.conversationID
        this.tim.setMessageRead({ conversationID })
      }
    }
  },
  methods:{
    onClickLeft() {
      this.$router.push('/chat')
    },
    onSendBoxToolbarShow() {
      if (this.sendBoxToolbarShow===true) {
        this.sendBoxToolbarShow=false
        this.toolbarStatus=0
      }else{
        this.sendBoxToolbarShow=true
        this.toolbarStatus=2
      }
      this.$bus.$emit('scroll-bottom')
    },
    onSendBoxEmojisShow() {
      if (this.sendBoxEmojisShow===true) {
        this.sendBoxEmojisShow=false
        this.toolbarStatus=2
        this.sendBoxToolbarShow=true
      }else{
        this.sendBoxEmojisShow=true
        this.toolbarStatus=1
        this.sendBoxToolbarShow=false
      }
      this.$bus.$emit('scroll-bottom')
    },
    onImageLoaded() {
      this.scrollMessageListToButtom()
    },
    handleSendImageClick() {
      this.$refs.imagePicker.click()
    },
    chooseEmoji(item) {
      this.messageContent += item
    },
    sendTextMessage() {
      if (
          this.messageContent === '' ||
          this.messageContent.trim().length === 0
      ) {
        this.messageContent = ''
        this.$toast('不能发送空消息哦')
        return
      }
      const message = this.tim.createTextMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: { text: this.messageContent }
      })
      this.$store.commit('conversation/pushCurrentMessageList', message)
      this.$bus.$emit('scroll-bottom')
      this.tim.sendMessage(message).catch(error => {
        this.$toast.fail(error.message)
      })
      this.messageContent = ''
    },
    sendImage() {
      const message = this.tim.createImageMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          file: document.getElementById('imagePicker') // 或者用event.target
        },
        onProgress: percent => {
          this.$set(message, 'progress', percent) // 手动给message 实例加个响应式属性: progress
        }
      })
      this.$store.commit('conversation/pushCurrentMessageList', message)
      this.tim
          .sendMessage(message)
          .then(() => {
            this.$refs.imagePicker.value = null
            this.$bus.$emit('scroll-bottom')
          })
          .catch(imError => {
            this.$toast.fail(imError.message)
          })
    },
    handleSendJobClick(item) {
      if (isEmpty(item.value)) {
        this.$toast('请先选择要发送的职位')
        return
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration:0,
      })
      this.$store.dispatch(
          'company/sendJobChat',
          {
            userId:this.userID,
            jobId:item.value,
            toUserId:this.toAccount
          },
      )
      this.sendJobsShow = false
      this.$toast.clear()
      this.$bus.$emit('scroll-bottom')
    },
    handleSendViewResumeClick() {
      /*if (this.endTalkList.indexOf(this.conversationID) !== -1){
        this.$store.commit('showMessage', {
          message: "对方已结束洽谈，请您及时结束洽谈。如需洽谈，请重新申请。",
          type: 'error'
        })
        return false;
      }*/
      const message = this.tim.createCustomMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          data: JSON.stringify({id:new Date().getTime()}),
          description: '[查看简历]',
          extension: 'get_resumes'
        }
      })
      this.$store.commit('conversation/pushCurrentMessageList', message)
      this.tim.sendMessage(message).catch(error => {
        this.$toast.fail(error.message)
      })
      this.$bus.$emit('scroll-bottom')
    },
    handleSendMobileCompanyClick() {
      /*if (this.endTalkList.indexOf(this.conversationID) !== -1){
        this.$store.commit('showMessage', {
          message: "对方已结束洽谈，请您及时结束洽谈。如需洽谈，请重新申请。",
          type: 'error'
        })
        return false;
      }*/
      let phoneData=this.imUserInfo.mobile
      if (isEmpty(phoneData)) {
        this.$toast.fail('请先填写手机号码，再发送哦！')
        return
      }
      const message = this.tim.createCustomMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          data: JSON.stringify({phone:phoneData}),
          description: '[手机号码]',
          extension: 'phone'
        }
      })
      this.$store.commit('conversation/pushCurrentMessageList', message)
      this.tim.sendMessage(message).catch(error => {
        this.$toast.fail(error.message)
      })
      this.$bus.$emit('scroll-bottom')
    },
    handleSendResumeClick(item) {
      /*if (this.endTalkList.indexOf(this.conversationID) !== -1) {
        this.$toast('对方已结束洽谈，请您及时结束洽谈。<br>如需洽谈，请结束后重新申请。')
        return false
      }*/
      if (isEmpty(item.value)) {
        this.$toast('请先选择要发送的简历')
        return
      }
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration:0,
      })
      this.$store.dispatch(
          'person/sendResumeChat',
          {
            userId:this.userID,
            resumeId:item.value,
            toUserId:this.toAccount
          },
      )
      this.sendResumeShow = false
      this.$toast.clear()
      this.$bus.$emit('scroll-bottom')
    },
    handleSendMobilePersonClick() {
      // if (this.endTalkList.indexOf(this.conversationID) !== -1){
      //   this.$store.commit('showMessage', {
      //     message: "对方已结束洽谈，请您及时结束洽谈。如需洽谈，请重新申请。",
      //     type: 'error'
      //   })
      //   return false;
      // }
      let phoneData=this.imUserInfo.mobile
      if (isEmpty(phoneData)) {
        this.$toast.fail('请先填写手机号码，再发送哦！')
        return
      }
      const message = this.tim.createCustomMessage({
        to: this.toAccount,
        conversationType: this.currentConversationType,
        payload: {
          data: JSON.stringify({phone:phoneData}),
          description: '[手机号码]',
          extension: 'phone'
        }
      })
      this.$store.commit('conversation/pushCurrentMessageList', message)
      this.tim.sendMessage(message).catch(error => {
        this.$toast.fail(error.message)
      })
      this.$bus.$emit('scroll-bottom')
    },
    // 直接滚到底部
    scrollMessageListToButtom() {
      this.$nextTick(() => {
        // let messageListNode = this.$refs['messageList']messageList
        // let messageListNode = this.$refs['messageList-box']
        let messageListNode = this.$el.querySelector('.messageList-box')
        if (!messageListNode) {
          return
        }
        messageListNode.scrollTop =messageListNode.scrollHeight
      })
    },
    async deleteConversationConfirm() {
      await this.$store.dispatch('common/endTalk',{
        userId: this.userID,
        toUserId: this.toAccount,
        talk_id:this.toUserData.talk_id,
        evaluate_id:this.toUserData.evaluate_id,
        evaluate_status:this.rateValue,
      })
      this.closeNegotiationDialog = false
      await this.$router.push('/chat')
    },
    onLoad() {
      if (this.scrollMessageListOne<1) {
        this.$bus.$emit('scroll-bottom')
        this.scrollMessageListOne++
      }
      if (this.isCompleted) {
        this.finished = true
      }else{
        this.$store.dispatch('conversation/getMessageList', this.currentConversation.conversationID)
        this.loading =false
      }
    },
    isEmptyVal(param) {
      return isEmpty(param)
    },
    jumpCompany() {
      const userId = this.toAccount
      let userIdData = userId.split('|')
      this.$router.push({ name: 'company', query: { companyId: userIdData[4] } })
    },
  },
}
</script>

<style lang="stylus" scoped>
body{
  margin-bottom:0 !important;
}
.chats{
  background-color: #ebeef3;
  height: 100vh;
}
.toUserInfo-box{
  border-top: 1px solid #ddd;
  margin-top:48px;
  padding: 10px;
  .line-1{
    display: flex;
    justify-content: space-between;
    font-size: .3rem;
    .resume-name{
      color: #333333;
      width: 50%;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: .3rem;
    }
    .chat-title{
      color: #747474;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 50%;
      text-align: right;
      font-size: .3rem;
      .job-name{
        color: #00c4cc;
        overflow: hidden;
      }
    }
  }
  .line-2{
    display: flex;
    padding: 8px 0;
    font-size: .28rem;
    color: #636363;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    .icon_edu{
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAYAAAB/TkaLAAADaklEQVQ4jXWUT0vzWhCHn5PGNG2CbQQVEYqgSPyD0EWr7UIU0a1+Aj+An0bwY7hyJRTcaPEVFVREQaVUqaiIWkWtbZOc3IU3sX29dyCLHM48M/ObmSN83/dpseDX930URUFKied5XF9fI6VkeHgYIUR4X0oJgKIo4Zn4G9pqX19fXFxcUCwWeXx8RFVVent7mZ6exrbtX/AAHEJ930dKiRAC13U5ODhgd3eXWq1GPp8nk8lQr9fZ39/n+PgY0zRZWFhgdHS0Lcs2qOd5uK7LyckJhUIBRVHI5XJkMhlM02xzenl54c+fP+zv72NZFnNzc4yOjiKEQFGUb+jn5yfFYpG9vT1isRgzMzOMj48Tj8d/aS2EwPd9hBBUq1WOj48pFovE43Hy+TzZbBZRrVb91dVVPj8/WVpaYmpqKoz4dwNbga1a1ut1Njc32d7eJp1Oo0SjUVKpFPF4nNPTU46Ojvj4+MDzvDA7z/PaQK329PTE4eEhlUqFZDJJX1/fj6Z3d3ecnp6ytbWFYRiMjY2RzWZJpVJt2QaByuUyOzs7XF5e4roui4uLjIyMkEgkfo/U2toaiUSCZrPJ/f09XV1dZDIZbNvG87xwxD4+PrBtG13Xub29ZWVlJZRMDTQKuq8oCul0mvHxcZ6fnzk6OmJ7e5tCoYDjOFiWRT6fx7ZtLMvi7OyMSqXC+/s7JycnTExMoAYZRiKRcFYdx0EIgWVZzM/Pk8vlqFQqAAwODqJpWihHvV5HUZSwWalUClUIEW5DMPyBIkE5hmEwMjISdrt1Ajo6OsJVDQKpgXOrDKqq4nleCJVS4rrut16q+rOO/yYkhAg/z/N+yg8uBcBIJALA29sbjUYjBEQiETRNwzTNtuqklKiqSiwWQ2kFBtBGowF8PygByPd9NE3D930cx8FxnHDEOjo6ME2T5eVlkskkbWujKAo9PT1cXV0BoOs6iUQCVVXRdR3XdTEMg2QySTQaRQjB+fk53d3dxONxhoaGMAyjHSqEYHJyklKpxMbGBuVymZeXFzRNQ9M0LMtCSsnr6yulUon19XVKpRLZbDbsC/zPe3pzc0OhUODh4QHHcb6jtzjVajVUVaW/v5/Z2VkGBgb++z1ttWDXa7UaX19fVKtVms0mUkqi0SidnZ0kEgl0XQ97AeC6Lqqq8g9rrtx5h6GILgAAAABJRU5ErkJggg==");
      background-position:left center;
      padding-left:1rem;
      background-size: 0.7rem;
      background-repeat: no-repeat;
    }
    .icon_exp{
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAB5ElEQVQ4jYWUzWpyMRCGn5mM2oqbQpfSGxCk4D10Ld5c6aY34XVIwUU33Qj+XICVqufkJN9CEuKp9BsI+Zu8876TSSReDBHhcDgwn89ZrVbEGDEzvPc45wghICLEGHl6emI6nXJ3d4dzDgALIaCqAGw2Gz4/P3l5eaHf71NVFb1ej6qqMDMA6rpmPp8zHo8ZjUYkM+89i8WCGCNfX18cj0e22y3OucwgBVJVqqrCe8/Hxwf7/R4zYzQaIW9vb3G32zEYDIgxcj6fcc7RNE3uRQQRoWkaVBURQVUxM76/vxkOh9h6vWY2m/H8/JxpJiblWERoWwiB1WrF+/s7Vh4urZzfAknraU//ckysYoy5lesloJUgpYSqqjidTlcS7+/v6XQ6N5lmae0N7z2n0ynXj4jgnMPMaAcHsDbNcp5uKCW8aZpfvhmofbgdLbWSWdtE5JLsNnpic+WomtduBbYySupjjHS7XR4eHq4CdLvdXzWV2FrS3q6bWzLKd5lAVBXnHNrpdFDVX4lsAyZ5QPZVVeq6vvwU3vuM2r7BW8De+/wTlHItUS5z9JeVIHCpt6ZpkNfX17jb7Xh8fPwvoxACZkYIIY8PhwODwQDZ7/dxuVzy8/Pzp6TU13VNr9fLF+ScYzKZ8A+LrS8d34DiDQAAAABJRU5ErkJggg==");
      background-position:left center;
      padding-left:1rem;
      background-size: 0.7rem;
      background-repeat: no-repeat;
    }
    .icon_age{
      background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAYAAAB7u5a2AAABc0lEQVQ4je3Uv45NURTH8c8ZI2OG8Z+QabyAVisaD6CSiEKjoxEFuVsiqyDxBLyBmkbDzTwBrdCSXAmZXOP/3KM4+yT7XveM61L6NXv9Vna+WWvtlV3Vda3UYDBow73YwF3cyLka6zid/Wscw25TtDgtmfUZF/GiyF3A28Jfwa4uQLVN5bCCb/iR/TK2cg6WUOHLTPBWKaV2LHci4mbO1ehHxJnsX+J4RKxOYyx0taSZL3yfyH+diKdWvS08IoY53JiAfSz8Jj51MX4ZS0ppCfuwile4p9mYHXiDPs7n630cwUlUETH2YGPwlNJl3O+qZAa9w9mIeE6xiimltQxexyOM8EGzMSuaN3iPnbkrmpGNcCD723iKg2NwnMjn1Ygod3tmpZSO4nrrywdtd3dtHnDWntKU8Hb41V/AFzrNv9Z/+G/hmxPnPCr/HVWv19uf41N4gkt47M+72sIDnMMhjBbxUPM/LGOIW7g2B3yEw5nxDMOfFlhtZK0nPFYAAAAASUVORK5CYII=");
      background-position:left .1rem;
      padding-left:1rem;
      background-size: .85rem;
      background-repeat: no-repeat;
    }
  }
  .line-3{
    .edu-item{
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 10px;
      .com-logo {
        i {
          display: block;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: #00c4cc url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAACA0lEQVRIia2WMUwUQRSGP+BENJqTmEAjDaWJsVFBbExskcRoA7EBYmJnZ2PsTIyxs7C2seEaiAWlkRjsKKyIsVCx4GLMGUAQzvO3mDfxMe7d7ip/8vJ25v1v/pnZN7OLJAraeUkPJW0ooCVpqmh+p+BhSVclLWo/liXdl7Rk7Vv/KjQraSUZvCZpQtKxhLts8a4yQsOSNi3xk6THksZyBpg2fjVPqEJABXgD/ATOAm8phqPme/KIUegcMABcLCHi838VJfab33KxXkAJvwtotunviG7ze25wgHlg1/q97RJmfyYZp5UnVEnaUfg57bdwD1i357iSjbJC8aXWzPLw1fwCMAlstyN2J+1074ugCUwA34G7RYX8S+0jrNBbX8I/aX4IeAY8At4Bl/KEmuZfADuEc+Vth7Dq08YTcAj4DEwDl4Eq8Bp44gdO31Fc0SKwljGReF6+Jf39QAN4BQwCD4B7wDAwHqYUrogrdpWMFL2Nze5Y3omM2E2LXZB0IMXgd8JjzvwIdC6G/0XVfCtLKBZDjbC6LPvB3zdDA5hxnBvAFy/UrhheApsZE5FNppH09wLvCSUO8AE44gmpUGw/pRyOA0tmEac84aCKIetSbfpGFFoz/7GkQN18eq58rA5hq0aBa9Z5G1gtIRTzZtn/LYM/37jrwBbubyb+RpVFp7wYq/8GNPJk85PEBCIAAAAASUVORK5CYII=") no-repeat center;
          background-size: 50%;
        }
      }
      .school-logo {
        i {
          display: block;
          width: 1.5rem;
          height: 1.5rem;
          border-radius: 50%;
          background: #00c4cc url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAYCAYAAAALQIb7AAACIklEQVRIia2Wv2sUQRTHP5c9E8UonAqeklRRIWhhYyGCxYFYWFkL8R9QbK1EIdpqp51XKNhYClpZWKgIgo02CiL+CoEoOYUcueRrMd9l55Zd9073C8PMvPfmfff9mGEbkhgTW4FbwGdgcayTksYZ85KWlOH+OOfHITptgu8mPef9c0nNOsku2vGTnPyE5SuSkjrILtvh7RL90Sjiqf8hO2tH1yvs2rZ7KWnyX8neS3o9Yqo7JjxcZtOMGnMXcAM4njYqMAtc8v4xsAfYiM4kwCpwBnhm2SNgCZiw7h5wFxgiuwksAB+9bwCTHgDrQN/yFAPL5Y8FmAL2WnYE6AAvgHdxmG8kvcqFLkndaN+StDMaLUkN647Z/lBB83TyaewRXoc8vnrecGqKMA188np3JG957ufTSImzND0zdrqZs+8Dv4E5y5JIP+Q/3pQ9kr88XyDUI66ZCDW7RsjMX5GPrAh9zwsMpyhFj/Agr9VB1vY8W2E3XwfZIFofAE4R0inCfXpgXVnzFJI1SmzSgp8HugX6ReAgWdeWovJrgGV/SBe4Q+jIBNhCiHSO8CB8qXI0Sjf+BLZ7fYXQ5hCuwAfgKXAS2FFFNkpkCVmKZwr0TeDHCH6GyMpqBlnURTYT1lf+zMRk6wy/6CnWyC520cUdePQKbNJzq5DVbJpQl21k9UmjaJHdtTbwLdLL9k1gv+X7CLWE8PpDSP9bJF1V/dj0iPHwD+VwDQQv0ne8AAAAAElFTkSuQmCC") no-repeat center;
          background-size: 50%;
        }
      }
      .edu-right{
        padding-left: .75rem;
        .edu-1{
          display: flex;
          align-items: center;
          width: 100%;
          .school{
            color: #323232;
            font-size: .26rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .period{
            color: #999999;
            font-size: .26rem;
            padding-left: .5rem;
          }
        }
        .profession{
          color: #787878;
          font-size: .26rem;
        }
        .empty{
          font-size: .28rem;
        }
      }
    }
  }
}
.editor-box{
  height 100vh

  .messageList-box{
    height: 76%;
    overflow-y: scroll;
    overflow-x: hidden;
    .messageList{
      height 100%
    }
  }
  .send-box{
    background-color: #ffffff;
    //height: 30%;
    padding: 10px;
    align-items: center;
    .input{
      border-radius: 0.3rem;
      background-color:#ebeef3;
      border: none;
      padding: 0.1rem 0.2rem;
    }
  }
  .tool{

  }
  .emojis{
    height: 5.2rem;
    overflow-y: auto;
  }
}
.rate-content{
  padding 20px;
  text-align: center;
}
</style>
